import React from 'react';

import { Redirect } from 'react-router';


const Internal = (props) => {
    return (
        <div>
            <Redirect to={"/"+props.match.params.AppId+"/"+props.internal}></Redirect>
        </div>
    );
};

export default Internal;